import { render } from "./SensorItem.vue?vue&type=template&id=6f4ba6a2&scoped=true"
import script from "./SensorItem.vue?vue&type=script&lang=js"
export * from "./SensorItem.vue?vue&type=script&lang=js"

import "./SensorItem.vue?vue&type=style&index=0&id=6f4ba6a2&lang=scss&scoped=true"

import exportComponent from "/home/www/www.alb-bayern.de/bottle/www/apps/alb_development/frontend/mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f4ba6a2"],['__file',"src/components/sensor/SensorItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6f4ba6a2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6f4ba6a2', __exports__)) {
    console.log('reload')
    api.reload('6f4ba6a2', __exports__)
  }
  
  module.hot.accept("./SensorItem.vue?vue&type=template&id=6f4ba6a2&scoped=true", () => {
    console.log('re-render')
    api.rerender('6f4ba6a2', render)
  })

}


export default __exports__